<template>
  <div>
    <template v-if="loading">
      <loader/>
    </template>
    <template v-else>
      <div class="d-flex justify-content-center">
        <h3 class="mb-3">Nabídka placených služeb</h3>
      </div>
      <p class="text-center">
        Počet logovaných argumentů {{ getLoggingEnabledVars.length }} vytvořilo za posledních 30 dní
        {{ subscription.records_per_month }} záznamů.
      </p>
      <template v-if="!subscription.logging_payments_handled_by_partner">
        <template v-if="hasSubscription">
          <p class="text-center text-info">
            <span v-if="subscription.is_active">
          Aktuálně máte <span>aktivní</span> předplatné <strong>{{
                subscription.product_name
              }}</strong>, <strong
              v-if="subscription.is_paid">uhrazeno do {{ paidTo }}</strong><strong
              v-else>neuhrazeno</strong>
              </span>
            <span v-else>
          Aktuálně máte ukončené předplatné <strong>{{
                subscription.product_name
              }}</strong>, <strong
              v-if="subscription.is_paid">stále platné do {{ paidTo }}</strong><strong
              v-else>neuhrazeno</strong>
              </span>
          </p>
        </template>
        <template v-else>
          <p class="text-center text-info">
            <span>Momentálně <template v-if="hasFreeTier">využíváte služeb zdarma</template><template
              v-else>nemáte aktivované placené služby</template> a můžete bezplatně využít {{
                getAllowedArgumentsCount
              }} argumentů a {{ getAllowedRecordsCount }} záznamů.</span>
          </p>
        </template>
        <div class="d-flex justify-content-center" v-if="!hasSubscription && !hasFreeTier">
          <b-button v-if="getLoggingEnabledVars.length > 10" variant="outline-primary" class="mb-3"
                    v-b-modal.confirm-free-tier-modal>
            Chci zůstat u služeb zdarma
          </b-button>
          <b-button v-else variant="outline-primary" @click="stayOnFreeTariff" class="mb-3"
                    v-b-modal.confirm-free-tier-modal>
            Chci zůstat u služeb zdarma
          </b-button>
        </div>
        <p class="text-center">V případě ročního předplatného je měsíční cena o 20% nižší</p>
        <b-container fluid>
          <div class="d-flex justify-content-center">
            <div v-if="hasSubscription" class="text-center mb-3">
              <p v-if="subscription.is_active">Pokud chcete změnit tarif služeb, musíte nejprve
                zrušit
                aktuální tarif.</p>
              <b-button v-if="subscription.is_active" variant="danger"
                        v-b-modal.cancel-confirm-modal>
                Zrušit placené služby
              </b-button>
            </div>
          </div>
          <div class="d-flex justify-content-center mb-3">
            <toggle-button
              :font-size="20"
              :width="140"
              :height="40"
              :labels="{checked: 'Roční', unchecked: 'Měsíční'}"
              :color="{checked: '#ff5fa7', unchecked: '#8c80ff'}"
              :switch-color="{checked: '#e2277b', unchecked: '#5d4fd9'}"
              v-model="yearly"
            />
          </div>
          <div class="d-flex justify-content-center">
            <b-card-group deck class="mb-3">
              <b-card
                v-for="(product, index) in products"
                :key="`product-${index}`"
                v-if="(yearly && product.period === 'Y') || (!yearly && product.period === 'M')"
                style="max-width: 300px"
                :title="product.title"
              >
                <template #header>
                  <h4 class="mb-0">{{ product.name }}</h4>
                </template>
                <b-card-text>{{ product.text }}</b-card-text>
                <a v-if="!subscription.is_active" :href="simpleShopUrl(product.url)"
                   target="_blank">Objednat</a>
                <strong class="text-info"
                        v-if="subscription.product_id + '' === product.id && subscription.is_active">Aktivní</strong>
              </b-card>
            </b-card-group>
          </div>
          <div class="d-flex justify-content-center">
            <b-button variant="primary" @click="refreshSubscription">
              Obnovit stránku
            </b-button>
          </div>
        </b-container>
        <b-container v-if="log.length > 0">
          <hr class="mt-5"/>
          <div class="d-flex justify-content-center">
            <h3 class="mb-3">Historie objednávky placených služeb</h3>
          </div>
          <b-table hover :items="log"
                   :fields="[{key: 'date', label: 'Datum'}, {key: 'text', label: 'Poznámka'}]"
                   sort-by="date" :sort-desc="true">

            <template v-slot:cell(text)="{ item }">
              <span v-html="getLogItemUpdatedText(item)"></span>
            </template>
          </b-table>
        </b-container>
        <b-modal id="cancel-confirm-modal" title="Opravdu zrušit placené služby?" ok-only
                 ok-title="Opravdu zrušit" ok-variant="danger" :ok-disabled="!isCancelable"
                 @ok="cancelSubscription">
          <template v-if="!isCancelable">
            <strong>Zdá se, že máte službu objednanou teprve nedávno a ještě nemáme vše v naší
              databázi, aby šlo placené služby zrušit. Vraťte se prosím za pár minut a obnovte
              stránku.</strong>
          </template>
          <template v-else>
            <strong>Tento krok je nevratný</strong>
            <p v-if="subscription.is_paid" class="my-4">Služby máte předplacené až do
              <strong>{{ paidTo }}</strong>. Do té doby budou stále aktivní.</p>
          </template>
        </b-modal>
        <b-modal id="confirm-free-tier-modal"
                 title="Překročení limitu počtu argumentů pro služby zdarma" ok-only
                 ok-title="Ok" ok-variant="danger">
          <strong class="text-red">Aktuálně logujete více než 10 argumentů, a pro využití logování
            zdarma prosím snižte počet argumentů na max limit 10.</strong>
        </b-modal>
      </template>
      <template v-else>
        <p class="text-center">
        <strong>Logování za vás hradí váš instalační partner - {{ subscription.partner_name }}</strong>
        </p>
      </template>
    </template>
  </div>
</template>

<script>
import BreadcrumbsManager from '@/mixins/BreadcrumbsManager';
import ToasterMixin from '@/mixins/Toaster';
import config from '@/config';
import axios from 'axios';
import {mapGetters, mapState} from 'vuex';
import Loader from '@/components/utils/Loader.vue';
import moment from "moment/moment";

export default {
  name: 'Subscription',
  data() {
    return {
      yearly: true,
      loading: false,
      subscription: null,
    };
  },
  computed: {
    ...mapState('snapshot', [
      'currentSnapshot',
    ]),
    ...mapGetters([
      'getLoggingEnabledVars',
    ]),
    ...mapGetters('paid-subscription', [
      'getAllowedArgumentsCount',
      'getAllowedRecordsCount',
      'hasReachedMaxArgumentCount',
    ]),
    products() {
      let newList = [];
      for (let key in this.subscription.products) {
        newList.push({"id": key, ...this.subscription.products[key]});
      }
      return newList.sort((a, b) => a.order - b.order);
    },
    hasFreeTier() {
      return this.subscription && this.subscription.project.has_free_subscription;
    },
    hasSubscription() {
      if (!this.subscription) {
        return false;
      }
      return Boolean(this.subscription.project_id);
    },
    paidTo() {
      if (!this.subscription.paid_to) {
        return ''
      }
      return moment(this.subscription.paid_to).format('LL');
    },
    isCancelable() {
      if (!this.subscription) {
        return false;
      }
      return Boolean(this.subscription.id_recurrent_invoice);
    },
    log() {
      if (!this.hasSubscription || !this.subscription.logs) {
        return []
      }
      return this.subscription.logs.map((logItem) => {
        return {
          ...logItem,
          date: moment(logItem.date).format('LLL'),
        }
      });
    },
  },
  methods: {
    getLogItemUpdatedText(item) {
      let regex = /\{vfiid:.*?\}/g;
      if (item.invoice_url) {
        item.text = item.text.replace(regex, `<a href="${item.invoice_url}" target="_blank">Stáhnout</a>`);
      }
      let productRegex = /\{vfpid:\d+:(.*?)\}/g;
      item.text = item.text.replace(productRegex, (match, name) => name);
      return item.text;
    },
    async loadPaidSubscription() {
      const url = new URL(
        config.ICOOL.API.PAID_SUBSCRIPTION_PATH(this.currentSnapshot.id),
        config.ICOOL.BACKEND_HOST,
      ).href;
      try {
        const response = await axios.get(url);
        this.subscription = response.data;
        this.yearly = this.subscription?.period === 'Y';
      } catch (error) {
        this.showToast('Nepodařilo se načíst předplatné', 'Obraťte se na naši podporu', 'danger');
      }
    },
    async loadProjectSettings() {
      const url = new URL(
        config.ICOOL.API.PROJECT_SETTINGS_PATH(this.currentSnapshot.project),
        config.ICOOL.BACKEND_HOST,
      ).href;
      try {
        const response = await axios.get(url);
        this.projectSettings = response.data;
      } catch (error) {
        this.showToast('Nepodařilo se načíst nastavení projektu', 'Obraťte se na naši podporu', 'danger');
      }
    },
    simpleShopUrl(url) {
      return `${url}${this.currentSnapshot.project}`;
    },
    async cancelSubscription() {
      if (!this.isCancelable) {
        return;
      }
      const url = new URL(
        config.ICOOL.API.PAID_SUBSCRIPTION_PATH(this.currentSnapshot.id),
        config.ICOOL.BACKEND_HOST,
      ).href;
      try {
        await axios.delete(url);
        this.showToast('Hotovo', 'Zrušení předplatného bylo úspěšné', 'success');
      } catch (error) {
        this.showToast('Došlo k chybě', 'Obraťte se na naši podporu', 'danger');
      }
      this.refreshSubscription();
    },
    async stayOnFreeTariff() {
      if (this.getLoggingEnabledVars.length > 10) {
        return;
      }
      const url = new URL(
        config.ICOOL.API.PROJECT_SETTINGS_PATH(this.currentSnapshot.id),
        config.ICOOL.BACKEND_HOST,
      ).href;
      try {
        await axios.patch(url, {has_free_subscription: true});
        this.showToast('Hotovo', 'Nastavení bezplatných služeb', 'success');
      } catch (error) {
        this.showToast('Došlo k chybě', 'Obraťte se na naši podporu', 'danger');
      }
      this.refreshSubscription();
    },
    async refreshSubscription() {
      this.loading = true;
      await this.loadPaidSubscription();
      this.loading = false;
    }
  },
  mounted() {
  },
  mixins: [
    BreadcrumbsManager, ToasterMixin,
  ],
  components: {
    Loader,
  },
  async beforeMount() {
    await this.refreshSubscription();
  },
};
</script>

<style scoped></style>
